import './bookHero.css'

const BookHero = () => {
  return (
    <section className="bookHero">

      <div className="bookHero__container section__padding">

        <span className="bookHero__label">LIBRO</span>

        <h1 className="bookHero__title">
          Educación Menstrual
        </h1>        

        <a href="#comprar" className="bookHero__button">
          Comprar libro
        </a>

        <p className="bookHero__description">
          Es, a la vez, manual, glosario, manifiesto, y hoja de ruta: un recurso
          para educadoras, activistas, profesionales y comunidades que buscan
          transformar la cultura menstrual y poner la vida (en todas sus fases)
          en el centro.
        </p>
      </div>

    </section>
  )
}

export default BookHero
